import React, { useEffect, useState, } from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { mergeProps } from '@/utils/with-default-props';
import { isUndef } from '@/utils/func';
// get checked state
const getCheckedState = (props) => {
    return isUndef(props.checked) ? !!props.defaultChecked : !!props.checked;
};
const defaultProps = {
    size: 'medium',
    disabled: false,
    readOnly: false,
    loading: false,
};
const Switch = (props) => {
    const { prefix = 'cn-ui-m-', className, size, disabled, readOnly, loading, style, 
    // defaultChecked = false,
    checked, 
    // vibrative = true,
    onChange, ...others } = mergeProps(defaultProps, props);
    const initChecked = getCheckedState(props);
    const [hasChecked, setChecked] = useState(initChecked);
    const checkedPrefix = hasChecked ? '-checked' : '';
    const disabledPrefix = disabled ? '-disabled' : '';
    // class names of switch
    const switchClassNames = classNames(`${prefix}switch`, `${prefix}switch--${size}`, {
        [`${prefix}switch-${disabledPrefix}${checkedPrefix}`]: hasChecked || disabled,
    }, className);
    // class names of knob
    const switchKnobClassNames = classNames(`${prefix}switch-knob`, `${prefix}switch-knob--${size}${checkedPrefix}`);
    // class names of loading
    const switchLoadingClassNames = classNames(`${prefix}switch-knob-loading`, `${prefix}switch-knob-loading--${size}`);
    // on switch tap
    const onSwitchTap = (e) => {
        if (disabled || readOnly) {
            return;
        }
        const checkedValue = !hasChecked;
        if (!('checked' in props)) {
            setChecked(checkedValue);
        }
        if (onChange) {
            onChange(checkedValue, e);
        }
    };
    useEffect(() => {
        if (initChecked !== hasChecked) {
            setChecked(initChecked);
        }
    }, [checked]);
    return (React.createElement("div", { className: switchClassNames, style: style, onClick: onSwitchTap, ...others },
        React.createElement("div", { className: switchKnobClassNames }, loading ? (React.createElement(CnIcon, { className: switchLoadingClassNames, type: "icon-loading" })) : null)));
};
Switch.displayName = 'CnSwitch';
export { Switch as CnSwitch };
